import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Carousel } from '@factorialco/f0-react/dist/experimental'
import { ExternalLink } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useGetProductUpdates } from 'modules/product_updates/hooks/useGetProductUpdates'

import { LatestUpdatesProps } from '../types'
import { Item } from './_Item'

const COLUMNS = {
  default: 1,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 2,
} as const

const ModuleCarousel: React.FC<LatestUpdatesProps> = ({ module, moduleName }) => {
  const { productUpdates, loading } = useGetProductUpdates({
    alreadyReleased: true,
    moduleIdentifier: module,
  })
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const latestUpdates = productUpdates?.filter((update) => update.chargebeeModuleName) || []

  if (loading || latestUpdates.length === 0) {
    return null
  }

  return (
    <Box paddingY="s24">
      <Box paddingBottom="s24" flexDirection="row" justifyContent="spaceBetween">
        <Text size="300" weight="semibold" color="black">
          {i18n.t('marketplace.revamp.latest_updates', {
            module_name: moduleName,
          })}
        </Text>
        <F0Button
          icon={ExternalLink}
          label={i18n.t('marketplace.revamp.view_more')}
          variant="outline"
          onClick={() => {
            track(trackingEvents.productUpdates.goToProductUpdatesPage, {
              source: `marketplace_latest_product_updates`,
              module: module,
              origin: pathname,
            })
            navigate(
              navigation.discover.productUpdates.fullPath() +
                `?module=${latestUpdates[0]?.productModule.urlIdentifier}#module-filters`
            )
          }}
        />
      </Box>
      <Carousel columns={COLUMNS}>
        {latestUpdates.map((update) => (
          <Item
            key={update.id}
            title={update.title}
            description={update.shortDescription}
            image={update.thumbnail.src}
            onClick={() => {
              track(trackingEvents.productUpdates.goToProductUpdatesDetailPage, {
                source: `marketplace_latest_product_updates`,
                module: module,
                origin: update.slug,
              })
              navigate(navigation.discover.productUpdates.item.fullPath({ slug: update.slug }))
            }}
          />
        ))}
      </Carousel>
    </Box>
  )
}

export default ModuleCarousel
